/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
(function (window) {

  $(document).ready(function () {
    console.log('SocietyLimontaHQ - SS24');
    window.storeMarket = $("html").attr("data-market");
    handleShipmentsBar();
    initParallax();
    handlerStoreSelectForm();
    cartEventHandler();
    restyleFooterPaymentMethods();

    var ios = window.iOSversion();
    if (ios && ios[0] >= 13) {
      fixTouchiOS();
    }
  });

  function handlerStoreSelectForm() {

    $(".store-select-form").on("submit", function (e) {
      e.preventDefault();
    });

    $(".store-select-form select").on("change", function (e) {
      var shipTo = $(e.delegateTarget).val();

      if (shipTo !== window.storeMarket) {
        switch (shipTo) {
          case "it":
            window.location.href = "https://societylimonta.com";
            break;

          case "eu":
            window.location.href = "https://eu.societylimonta.com";
            break;

          /* case "uk":
            window.location.href = "https://uk.societylimonta.com";
            break; */

          case "eeu":
            window.location.href = "https://extraeu.societylimonta.com";
            break;

          case "us":
            window.location.href = "https://us.societylimonta.com";
            break;
          
         /*  case "ch":
            window.location.href = "https://ch.societylimonta.com";
            break; */

          case "au":
            window.location.href = "https://societylimonta.com.au";
            break;

          case "nz":
            window.location.href = "https://societylimonta.co.nz/";
            break;
        }
      }
    });
  }

  function handleShipmentsBar() {

    var hideShipmentsBarCookie = window.storeMarket + '-market_hide-shipments-bar';
    var countShipmentsBarShownTimesCookie = window.storeMarket + '-market_shipments-bar-shown-times';

    // Shipments bar
    if (window.Cookies.get(hideShipmentsBarCookie)) {
      $(".shipments-bar").remove();
    } else if (window.Cookies.get(countShipmentsBarShownTimesCookie) == 5) {
      $(".shipments-bar").remove();
      window.Cookies.remove(countShipmentsBarShownTimesCookie);
      window.Cookies.set(hideShipmentsBarCookie, true, {
        expires: 90
      });
    } else {
      var shownCount = window.Cookies.get(countShipmentsBarShownTimesCookie);
      shownCount = shownCount ? parseInt(shownCount) + 1 : 1;

      window.Cookies.set(countShipmentsBarShownTimesCookie, shownCount, {
        expires: 1
      });

      $(".shipments-bar").css("display", "flex");

      $(".shipments-bar button.shipments-bar__close-btn").one("click", function (e) {
        $(".shipments-bar").remove();
        window.Cookies.remove(countShipmentsBarShownTimesCookie);
        window.Cookies.set(hideShipmentsBarCookie, true, {
          expires: 90
        });
      });
    }
  }


  
  function restyleFooterPaymentMethods() {
    let paymentIcons = document.querySelectorAll(".Footer__Aside .icon-payment-method");
    paymentIcons.forEach(function (icon) {
      var titleElement = icon.querySelector("title");
      if (titleElement) {
        let spanElement = document.createElement("span");
        spanElement.innerHTML = titleElement.textContent;
        icon.replaceChild(spanElement, titleElement);
      }
    });
  }

  /* Cart Event Handler */
  function cartEventHandler() {
    $(document).on('theme:loading:end', function(event) {
      // console.log('cartEventHandler', event);
      const CURRENT_LANG = $("html").attr("lang");
      const CURRENT_MARKET = $("html").attr("data-current-market");
      // console.log('CURRENT_LANG', CURRENT_LANG);
      // console.log('CURRENT_MARKET', CURRENT_MARKET);

      const CartContainer = document.getElementById('shopify-section-cart-template');
      const DrawerContainer = document.getElementById('sidebar-cart');
      let cartType = 'drawer';
      let cartItemCount = 0;
      const cartTemplateCheck = document.querySelector('[data-section-id="cart-template"]');
      if (cartTemplateCheck) {
        const CartOptions = JSON.parse(cartTemplateCheck.getAttribute('data-section-settings'));
        if (CartOptions) {
          cartItemCount = CartOptions['itemCount'];
          cartType = (CartOptions['drawer'] ? 'drawer' : 'ajax');
        }
      }
      let url_to_fetch = `cart?view=${cartType}&timestamp=${Date.now()}`;
      if (
        (CURRENT_MARKET == 'ch' && CURRENT_LANG == 'fr')
        || (CURRENT_MARKET != 'gb' && CURRENT_MARKET != 'ch' && CURRENT_LANG == 'fr')
      ) {

        url_to_fetch = `/${CURRENT_LANG}/cart?view=${cartType}&timestamp=${Date.now()}`;

        // console.log('DrawerContainer', DrawerContainer);
        // console.log('CartContainer', CartContainer);

        const callback = function(mutationsList, observer) {
          /* console.log(mutationsList, observer); */
          fetch(url_to_fetch, {
            credentials: 'same-origin',
            method: 'GET'
          }).then(function (content) {
            /* console.log('content', content); */
            content.text().then(function (html) {
    
              var tempElement = document.createElement('div');
              tempElement.innerHTML = html;
    
              var cartNodeParent = document.querySelector('.Cart').parentNode;
              if (DrawerContainer) {
                // var currentScrollPosition = document.querySelector('.Drawer__Main').scrollTop;
                cartNodeParent.replaceChild(tempElement.querySelector('.Cart'), document.querySelector('.Cart'));
                // document.querySelector('.Drawer__Main').scrollTop = currentScrollPosition;
              } else if (CartContainer) {
                /* console.log('cartItemCount', cartItemCount); */
                if (cartItemCount === 0) {
                  document.innerHTML = tempElement.querySelector('.shopify-section').firstElementChild.innerHTML;
                } else {
                  cartNodeParent.replaceChild(tempElement.querySelector('.Cart'), document.querySelector('.Cart'));
                  document.querySelector('.PageHeader').innerHTML = tempElement.querySelector('.PageHeader').innerHTML;
                }
              }
              observer.disconnect();
            });
          });
        };

        const observer = new MutationObserver(callback);
        let config = { attributes: true, childList: true, subtree: false }
        if (CartContainer) {
          config = { attributes: true, childList: true, subtree: true }
        }
        if (DrawerContainer && !DrawerContainer.classList.contains('cart-processed')) observer.observe(DrawerContainer, config);
        if (CartContainer) observer.observe(CartContainer, config);
      }      
    });
  }

  function fixTouchiOS() {

    var touchingCarousel = false,
      touchStartCoords;

    document.body.addEventListener('touchstart', function (e) {
      if (e.target.closest('.flickity-slider')) {
        touchingCarousel = true;
      } else {
        touchingCarousel = false;
        return;
      }

      touchStartCoords = {
        x: e.touches[0].pageX,
        y: e.touches[0].pageY
      }
    });

    document.body.addEventListener('touchmove', function (e) {

      if (!(touchingCarousel && e.cancelable)) {
        return;
      }

      var moveVector = {
        x: e.touches[0].pageX - touchStartCoords.x,
        y: e.touches[0].pageY - touchStartCoords.y
      };

      if (Math.abs(moveVector.x) > 7)
        e.preventDefault()

    }, {
      passive: false
    });
  }

  function initParallax() {
    if ($(".RellaxBar.RellaxEnabled").length && window.matchMedia('(-moz-touch-enabled: 0), (hover: hover)').matches) {
      new Rellax(".RellaxBar.RellaxEnabled .RellaxBar__ImageWrapper", {
        speed: -7,
        center: false,
        round: true
      });
    }
  }

  window.shuffleArray = function (a) {
    var j, x, i;
    for (i = a.length - 1; i > 0; i--) {
      j = Math.floor(Math.random() * (i + 1));
      x = a[i];
      a[i] = a[j];
      a[j] = x;
    }
    return a;
  }

  window.updatePageBG = function (color) {
    var colors = window.bgColorMixer(color);

    $("body").css("background-color", colors.base);
    $(".template-collection .CollectionToolbar").css("background-color", chroma(colors.light).alpha(0.96));
  }

  window.bgColorMixer = function (color) {

    var defaultBGcolor = "#EEEEEE";
    var luminanceFactor = chroma(defaultBGcolor).luminance();

    if (color) {
      var colorLuminance = color ? chroma(color).luminance() : luminanceFactor;
      if (colorLuminance >= 0.5 && colorLuminance <= 0.9) {
        luminanceFactor = luminanceFactor * 0.9;
      } else if (colorLuminance >= 0 && colorLuminance < 0.5) {
        luminanceFactor = luminanceFactor * 0.8;
      }
    }

    return {
      base: chroma(color ? color : defaultBGcolor).luminance(luminanceFactor),
      light: chroma(color ? color : defaultBGcolor).luminance(luminanceFactor * 1.15),
      dark: chroma(color ? color : defaultBGcolor).luminance(luminanceFactor * 0.85)
    };
  }

  window.urlParam = function (name) {
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (results == null) {
      return null;
    } else {
      return decodeURI(results[1]) || 0;
    }
  }

  window.iOSversion = function () {
    if (/iP(hone|od|ad)/.test(navigator.platform)) {
      // supports iOS 2.0 and later: <https://bit.ly/TJjs1V>
      var v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
      return [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)];
    }
  }

  window.setCookie = function (cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  window.getCookie = function (cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  class LocalizationForm extends HTMLElement {
    constructor() {
        super();
        this.elements = {
            input: this.querySelector('input[name="language_code"], input[name="country_code"]')
        };
        this.querySelectorAll('select').forEach(item => {
            //console.log('element', item);
            item.addEventListener('change', this.onItemClick.bind(this));
        });
    }
    
    onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector('form');
        this.elements.input.value = event.target.value;
        if (form) form.submit();
    }
  }

  if (document.querySelector('localization-form')) customElements.define('localization-form', LocalizationForm);
}(window));

var links = document.links;
for (var i = 0, linksLength = links.length; i < linksLength; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].relList.add('noreferrer', 'noopener');
  }
}
